import { observer } from 'mobx-react-lite'

import style from './InsuredContracts.module.scss'
import { InsuredPrograms } from './InsuredPrograms/InsuredPrograms'

interface IProps {
    type: string
    companyId: string
}

export const InsuredContracts = observer((props: IProps) => (
    <div className={style.container}>
        <InsuredPrograms {...props} />
    </div>
))
